define(['angular','moment'], function(angular, moment) {


    /**
     * @class UnitBonusService
     */
    function UnitBonusService($rootScope, userService) {
        let self = this;

        let _order;

        const NB_MONTH_FOR_MAINTENANCE = 48;

        /**
         * Set the order model
         * @param {Object} order
         */
        self.setOrder = function(order) {
            _order = order;
            // initScenario();
        };

        self.isCS = function (){
            let person = userService.findPerson(_order.RDSRef);
            return person.user.role === 'CS';
        }


        /**
         * Get the numerical value for the rental contract type
         * @return {Number}
         */
        self.getContractTypeValue = function() {
            return _order.contract.contractType.code === 'LOC48'
                ? 48
                : _order.contract.contractType.code === 'LOC60'
                    ? 60
                    : _order.contract.contractType.code === 'LOC36'
                        ? 36
                        : 1;
        };

        self.getCateringSupportContractType = () => {
            return _order.cateringSupportContractType.code === 'LOC48'
                ? 48
                : _order.cateringSupportContractType.code === 'LOC60'
                    ? 60
                    : _order.cateringSupportContractType.code === 'LOC36'
                        ? 36
                        : 1;
        }

        self.isConquete = function() {
            return _order.contract.scenarioType.code === 'CONQUETE';
        };

        self.isRental = function() {
            return _order.contract.contractType.code !== 'ACHAT';
        };

        self.isNAP = function() {
            return _order.orderType.code === 'NAP';
        };

        self.isLaunchBimediaPay = function() {
            return _order.goodwillGestures && _order.goodwillGestures.amount.launchBimediaPay > 0;
        };

        self.isLaunchBBooster = function() {
            return _order.goodwillGestures && _order.goodwillGestures.amount.launchBBooster > 0;
        };
        self.isExceptionalOffer = function(){
            return _order.goodwillGestures && _order.goodwillGestures.amount.exceptionalOffer > 0;
        };
        self.isFullPremiumOffer = function(){
            return _order.goodwillGestures && _order.goodwillGestures.amount.fullPremiumOffer > 0;
        };
        self.isBgreenOffer = function(){
            return _order.goodwillGestures && _order.goodwillGestures.amount.bgreenOffer > 0;
        };
        self.isQuickInstallOffer = () => {
            return _order.goodwillGestures && _order.goodwillGestures.amount.quickInstall > 0;
        }

        self.getCommissionRate = function() {
            let rate = {
                hardAndSoft: 0,
                maintenance: 0,
                tpe: 0
            };

            let softwares = _order.options.filter(option => option.optionType.code === 'LOGICIEL_CAISSE');
            /**
             * Utilisation d'un HASH sur 8 bits pour savoir quels services est activé
             * Position du bit selon le service
             *  - ENCAISSEMENT : 1
             *  - TABAC : 2
             *  - PRESSE : 3
             *  - LIBRAIRIE : 4
             *  - BOULANGERIE : 5
             *  - FLEURISTE : 6
             *
             * Exemple avec ENCAISSEMENT + TABAC + LIBRAIRIE : 00001011
             */

            const masques = {
                ENCAISSEMENT: 0b00000001,
                TABAC: 0b00000010,
                PRESSE: 0b00000100,
                LIBRAIRIE: 0b00001000,
                BOULANGERIE: 0b00010000,
                FLEURISTE: 0b00100000
            };

            let hash = 0;

            softwares.forEach(option => {
                hash = hash | masques[option.label];
            });

            const TAUX_CONQUETE = moment(_order.dateSignature).isBefore('2026-01-01') ? 4.5 : 4;
            const TAUX_RENOUVELLEMENT = moment(_order.dateSignature).isBefore('2026-01-01') ? 1.75 : 1.5;
            const TAUX_BURALOG = moment(_order.dateSignature).isBefore('2026-01-01') ? 6 : 4;

            // Tabac + Presse + Librairie
            if (
                hash & masques['ENCAISSEMENT'] &&
                hash & masques['TABAC'] &&
                hash & masques['PRESSE'] &&
                hash & masques['LIBRAIRIE']
            ) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Tabac + Presse
            else if (hash & masques['ENCAISSEMENT'] && hash & masques['TABAC'] && hash & masques['PRESSE']) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Presse + Librairie
            else if (hash & masques['ENCAISSEMENT'] && hash & masques['PRESSE'] && hash & masques['LIBRAIRIE']) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Boulangerie + Presse
            else if (hash & masques['ENCAISSEMENT'] && hash & masques['BOULANGERIE'] && hash & masques['PRESSE']) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Tabac seul
            else if (hash & masques['ENCAISSEMENT'] && hash & masques['TABAC']) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Presse seul
            else if (hash & masques['ENCAISSEMENT'] && hash & masques['PRESSE']) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Librairie seul
            else if (hash & masques['ENCAISSEMENT'] && hash & masques['LIBRAIRIE']) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Boulangerie seul
            else if (hash & masques['ENCAISSEMENT'] && hash & masques['BOULANGERIE']) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Fleuriste seul
            else if (hash & masques['ENCAISSEMENT'] && hash & masques['FLEURISTE']) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Encaissement seul
            else if (hash & masques['ENCAISSEMENT']) {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : TAUX_RENOUVELLEMENT;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            // Sinon, dans les autres cas
            else {
                rate.hardAndSoft = self.isConquete() ? TAUX_CONQUETE : 2;
                rate.maintenance = TAUX_BURALOG;
                rate.tpe = TAUX_BURALOG;
            }
            return rate;
        };

        /**
         * Retourne la valeur totale des promotions sur les caisses
         * @param {Object} promotionValues la liste des valeurs pour chaque type promotion
         * @returns {Number}
         */
        self.calculatePromotionsTotalAmount = function(promotionValues) {
            return Object.values(promotionValues).reduce((total, currentValue) => {
                return total + currentValue;
            }, 0);
        };

        self.updateOrderUnitBonus = function() {
            let rate = self.getCommissionRate();
            _order.unitBonus.hardAndSoft = self.calculateSubTotalHardSoft(rate.hardAndSoft);
            _order.unitBonus.maintenance = self.calculateSubTotalMaintenance(rate.maintenance);
            _order.unitBonus.tpe = self.calculateSubTotalTpe(rate.tpe);
            _order.unitBonus.total = self.calculTotal();
        };

        self.calculTotal = function() {
            _order.unitBonus.hardAndSoft = parseFloat(_order.unitBonus.hardAndSoft);
            _order.unitBonus.maintenance = parseFloat(_order.unitBonus.maintenance);
            _order.unitBonus.tpe = parseFloat(_order.unitBonus.tpe);
            return _order.unitBonus.hardAndSoft + _order.unitBonus.maintenance + _order.unitBonus.tpe;
        };

        self.calculateSubTotalHardSoft = function(rate) {
            let subtotal = 0;

            subtotal += _order.prices.till;
            subtotal += _order.prices.tillSoftware;
            subtotal += _order.prices.tillAccessories;
            subtotal += _order.prices.tabletAndPC;
            subtotal += _order.prices.cashDrawers;
            subtotal += _order.prices.warrantyExtension;
            subtotal += _order.prices.scanup;
            subtotal += _order.prices.scanupOptions;
            subtotal += _order.prices.flashup;
            subtotal += self.isRental() ? _order.prices.printerRental : _order.prices.printerPurchase;
            subtotal += _order.prices.tpeOptions;
            subtotal += _order.prices.packageInstallation;
            // subtotal += _order.prices.reintegration;
            subtotal -= self.calculatePromotionsTotalAmount(_order.prices.promotions);
            subtotal -=  _order.goodwillGestures &&  _order.goodwillGestures.generosity && _order.goodwillGestures.generosity.renunciationClubBimedia ? _order.goodwillGestures.amount.clubBimedia : 0;


            subtotal *= self.getContractTypeValue();

            if (!self.isNAP()) {
                if (self.isLaunchBimediaPay()) {
                    // On offre 12 mois l'option
                    subtotal += _order.prices.scanupBimediaPayOptions * (self.getContractTypeValue() - 12);
                    // si location la remise sur encaissement mobile x la durée du contrat sinon on soustrait la remise (249.75€)
                    self.isRental()
                        ? (subtotal -= _order.prices.scanupBimediaPayDiscount * self.getContractTypeValue())
                        : _order.prices.scanupBimediaPayDiscount;
                }
                else {
                    subtotal += _order.prices.scanupBimediaPayOptions * self.getContractTypeValue();
                }

                // on offre 12 mois à 6€ (72,00€) et le reste du contrat au prix de l'option
                subtotal += self.isLaunchBBooster()
                    ? _order.prices.BBoosterOptions * (self.getContractTypeValue() - 12) + 72
                    : _order.prices.BBoosterOptions * self.getContractTypeValue();

                subtotal +=_order.prices.prestationCateringSupport ? _order.prices.prestationCateringSupport * self.getCateringSupportContractType() : 0;
                subtotal -= self.isExceptionalOffer() ? _order.goodwillGestures.amount.exceptionalOffer * self.getContractTypeValue() : 0;
                subtotal -= self.isFullPremiumOffer() ? _order.goodwillGestures.amount.fullPremiumOffer * self.getContractTypeValue() : 0;
                subtotal -= self.isBgreenOffer() ? _order.goodwillGestures.amount.bgreenOffer * self.getContractTypeValue() : 0;
                subtotal -= self.isQuickInstallOffer() ? _order.goodwillGestures.amount.quickInstall * self.getContractTypeValue() : 0;
            }

            return (subtotal * rate) / 100;
        };

        self.calculateSubTotalMaintenance = function(rate) {
            let subTotalMaintenance = 0;

            subTotalMaintenance += _order.prices.maintenanceTill + _order.prices.sav;
            subTotalMaintenance += _order.prices.gestion;
            subTotalMaintenance *= self.isRental() ? self.getContractTypeValue() : NB_MONTH_FOR_MAINTENANCE;

            // return self.isNAP() ? 0 : subTotalMaintenance * rate / 100;
            return (subTotalMaintenance * rate) / 100;
        };

        self.calculateSubTotalTpe = function(rate) {
            let subTotalTPE = 0;
            subTotalTPE += _order.prices.tpe;
            subTotalTPE *= self.isRental() ? self.getContractTypeValue() : NB_MONTH_FOR_MAINTENANCE;

            return (subTotalTPE * rate) / 100;
        };

        return self;
    }

    UnitBonusService.$inject = ['$rootScope', 'userService'];

    angular.module('app.bdc.list.unitBonusService', []).factory('unitBonusService', UnitBonusService);
});
